import React from 'react';

import Services from '../Services/Services';

const ModuleServices = ({ services, primaryColor, uiVariantServices }) => {
  return (
    <div className="container">
      <Services
        services={services}
        primaryColor={primaryColor}
        uiVariantServices={uiVariantServices}
      />
    </div>
  );
};

export default ModuleServices;
